export default __webpack_public_path__ + "static/media/PencilEdit.f2df792b.svg";